<template>
    <div class="flex-auto" :class="[centering ? 'centering-grid ' : '', stage == 'init'? 'main-body': 'main-body-white']">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: "Body",
    props: {
        centering: {
            type: Boolean,
        },
        stage: {
            type: String,
            default: 'init'
        },
    },
};
</script>

<style lang="scss" scoped>

$body-radius: 32px;
.main-body {
    background-color: #0a0a0a;
    box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.05);
    // border-radius: $body-radius $body-radius 0px 0px;
    padding: 32px 24px;
}
.main-body-white {
    background-color: #ffffff;
    box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.05);
    border-radius: $body-radius $body-radius 0px 0px;
    padding: 32px 24px;
}

.centering-grid{
    display: grid;
    align-items: center;
};
</style>
